import { useTranslation } from "@/core/i18n";

import { SmsComplianceLinks } from "../SmsComplianceLinks/SmsComplianceLinks";

type TranslateFn = ReturnType<typeof useTranslation>["t"];

// Informational disclosure that transactional (service) texts — the verification code
// and reminders — will be sent to the entered number. Shown below the phone input from
// page open so every user (new or returning) sees it before submitting a number. There
// is no opt-in checkbox: these are messages the user is signing up to receive.
// Sender rule mirrors the marketing opt-in: name the practice, fall back to a generic
// "us" so a sender is always identified.
export const buildTransactionalSmsNotice = (
  t: TranslateFn,
  practiceName?: string | null,
): string => {
  const sender = practiceName ? practiceName : t("transactionalSmsNotice.genericSender");
  return t("transactionalSmsNotice.notice", { sender });
};

type TransactionalSmsNoticeProps = {
  /** Practice name interpolated as the sender (e.g. platform name). */
  practiceName?: string | null;
  className?: string;
};

// The Terms/Privacy links are part of the disclosure block, not decoration: Twilio's
// compliance review (2026-07) rejected footer-only links and requires them inside the
// opt-in disclosure itself. Keep them rendered with the notice text as one block — the
// footer links are no longer the compliance mechanism.
export const TransactionalSmsNotice = ({
  practiceName,
  className = "",
}: TransactionalSmsNoticeProps) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <p className="text-[11px] leading-4 text-secondary">
        {buildTransactionalSmsNotice(t, practiceName)}
      </p>
      <SmsComplianceLinks className="mt-1.5" />
    </div>
  );
};
